import Response from "../../Data/Domain/Response";
import CarbonFlux from "../Domain/CarbonFlux";
import { getCarbonFlux } from "./CarbonFlux.service";

export async function getCarbonFluxRepository(params) {
  const data = await getCarbonFlux(params);
  return new Response(data, CarbonFlux).getMultiple();
}